<template>
  <div class="modal" :id="modalId" tabindex="-1" aria-labelledby="confirmationModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static" >
    <div class="modal-dialog modal-content card border-danger">
        <div class="card-header p-2 text-white bg-danger">
          <slot name="modal-icon"></slot>{{ title }}
          <button id="close-modal-icon" type="button" class="close" @click="closeModal" aria-label="Cancelar">
            <i class="fal fa-times"></i>
          </button>
        </div>
        <div class="card-body">
          <slot name="modal-content"></slot>
          <!-- Check to confirm action -->
          <p class="mb-0">¿Estás seguro de continuar?</p>
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="confirmation-input" v-model="confirmationChecked">
            <label class="custom-control-label" for="confirmation-input">Sí, estoy seguro</label>
          </div>
        </div>
        <div class="card-footer pr-2 text-right">
          <button type="button" class="btn mr-2 btn-sm btn-secondary" @click="closeModal">Cancelar</button>
          <button type="button" class="btn m-0 btn-sm btn-outline-danger" :disabled="!confirmationChecked" @click="confirmationDone">Continuar</button>
        </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  props: {
    modalId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      confirmationChecked: false
    }
  },
  methods: {
    confirmationDone () {
      this.$emit('confirmation-done')
      this.confirmationChecked = false
      this.closeModal()
    },
    closeModal () {
      this.confirmationChecked = false
      const modal = document.getElementById(this.modalId)
      modal!.style.display = 'none'
    }
  }
})
</script>

<style lang="scss" scoped>
.modal {
  display: none;
  position: fixed;
  z-index: 1050;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0,0,0);
  background-color: rgba(0,0,0,0.4);
}

#close-modal-icon.close {
  color: #fff;
}
</style>
